<template lang="pug">
  #Productos
    Header

    //- ── Breadcrumb ─────────────────────────────────────────────────────────
    div.breadcrumb-bar
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='11')
            div.breadcrumb-inner
              a.bread-link(href='/') Inicio
              span.bread-sep /
              span.bread-current Productos

    //- ── Departamentos ──────────────────────────────────────────────────────
    div.depart-bar
      v-container(fluid)
        v-skeleton-loader.mx-auto#ld6(v-if='policeDepart' style='width:100%;' type='image')
        div(v-if='departamentos && departamentos.length > 0')
          carousel(:perPageCustom="[[320, 2],[480, 3], [768, 5], [1160, 9]]")
            slide(v-for='(item,i) in departamentos' :key='i' style='padding: 0 6px;text-align:center;')
              div.depart-item(@click='obtenerDepart(item.co_lin)')
                div.depart-icon-wrap
                  img(:src='ruta + item.imagen' class='depart-icon')
                span.depart-name {{item.lin_des}}

    //- ── Contenido principal ────────────────────────────────────────────────
    div.main-content
      v-container(fluid)
        v-row(justify='center')
          v-col(cols='12')
            v-row

              //- ── Sidebar filtros ──────────────────────────────────────────
              v-col.sidebar-col(cols='12' sm='12' md='3')

                //- Categorías (solo sin búsqueda activa)
                div.filter-panel(v-if='policeCat && !searchFacets')
                  v-skeleton-loader.mx-auto#ld7(style='width:100%;' type='image')
                div.filter-panel(v-if='!searchFacets && categorias && categorias.length > 0')
                  div.filter-title Categorías
                  v-radio-group#rd(v-model='seleccionCatId' column='' hide-details='')
                    v-radio(v-for='(item, i) in categorias.slice(0, 10)' :key='"cat"+i' :label='item.subl_des' :value='item._id')
                  div.ver-mas(@click='abrirModal("cat")') Ver más

                //- Subcategorías
                div.filter-panel(v-if='policeSub')
                  v-skeleton-loader.mx-auto#ld7(style='width:100%;' type='image')
                div.filter-panel(v-if='subcategorias && subcategorias.length > 0')
                  div.filter-title Subcategorías
                  v-radio-group#rd(v-model='seleccionSub' column='' hide-details='')
                    v-radio(v-for='(item, i) in subcategorias.slice(0, 10)' :key='"sub"+i' :label='item.des_color' :value='item.co_color')
                  div.ver-mas(@click='abrirModal("subcat")') Ver más

                //- Marcas
                div.filter-panel(v-if='policeMarc')
                  v-skeleton-loader.mx-auto#ld7(style='width:100%;' type='image')
                div.filter-panel(v-if='marcas && marcas.length > 0')
                  div.filter-title Marcas
                  v-radio-group#rd(v-model='seleccionMarc' column='' hide-details='')
                    v-radio(v-for='(item, i) in marcas.slice(0, 10)' :key='"marc"+i' :label='item.cat_des' :value='item.co_cat')
                  div.ver-mas(@click='abrirModal("marc")') Ver más

              //- ── Grid productos ───────────────────────────────────────────
              v-col(cols='12' sm='12' md='9')

                //- Chips de filtros activos
                div.active-filters(v-if='seleccionDep || seleccionCat || seleccionSub || seleccionMarc')
                  div.filter-chip(v-if='seleccionDep')
                    span {{obtenerNombreDep(seleccionDep)}}
                    v-icon(small @click='limpiarDep()') mdi-close
                  div.filter-chip(v-if='seleccionCat')
                    span {{obtenerNombreCat(seleccionCatId)}}
                    v-icon(small @click='limpiarCat()') mdi-close
                  div.filter-chip(v-if='seleccionSub')
                    span {{obtenerNombreSub(seleccionSub)}}
                    v-icon(small @click='limpiarSub()') mdi-close
                  div.filter-chip(v-if='seleccionMarc')
                    span {{obtenerNombreMarc(seleccionMarc)}}
                    v-icon(small @click='limpiarMarc()') mdi-close

                //- Skeletons
                v-row(v-if='policeProd' style='margin-top:8px;')
                  v-col(cols='12' sm='6' md='4' v-for='(item, i) in arrayPro' :key='i')
                    v-skeleton-loader.mx-auto#ld7(style='width:100%;' type='image')

                //- Grid
                v-row(v-if='listado && listado.length > 0' style='margin-top:8px;')
                  v-col(cols='12' sm='6' md='4' v-for='(item, index) in listado' :key='index')
                    div.prod-card(@click='ir(item._id)')
                      div.prod-img-area
                        img(v-if='item.images && item.images.url' :src='ruta + item.images.url' class='prod-img')
                        img(v-else src='@/assets/imgFerco/image.png' class='prod-img')
                        div.prod-badge-sin(v-if='mostrarS && (!item.existencia || item.existencia <= 0)') Sin stock
                      div.prod-body
                        span.prod-name {{item.nombre}}
                        span.prod-ref(v-if='item.ref') Ref: {{item.ref}}
                        span.prod-modelo(v-if='item.modelo') {{item.modelo}}
                        span.prod-marca {{item.marca}}
                        div.prod-footer
                          span.prod-stock(v-if='mostrarS && item.existencia && item.existencia > 0') Stock: {{item.existencia}}
                          div.prod-precio-wrap(v-if='mostrarP')
                            span.prod-precio ${{item.precioUnidad}}
                            span.prod-precio-paq(v-if='item.equivalente > 1') Paq: ${{item.precio}} x{{item.equivalente}}
                        div.prod-cart-row(@click.stop='')
                          v-btn(icon small @click.stop='decrementar(index)')
                            v-icon(small) mdi-minus
                          span.prod-cant {{cantidades[index] || item.equivalente || 1}}
                          v-btn(icon small @click.stop='incrementar(index, item)')
                            v-icon(small) mdi-plus
                          v-btn.prod-add-btn(small depressed color='#0F4DFF' dark @click.stop='añadirCarritoLista(item, index)')
                            v-icon(small) mdi-cart
                            span Agregar

                //- Paginación
                div.pagination-wrap(v-if='cantidad > 0')
                  v-pagination(v-model='pagination.page' :length='listar()' color='#0F4DFF')

    Search(v-if='dialogSearch' :modal="dialogSearch" :tipo='tipoSearch' :resultados='datosSearch' @action="actionSearch" @close="close")
    Footer
</template>

<script>
import Footer from '@/components/Footer.vue'
import Header from '@/components/Header.vue'
import Search from '@/components/Search.vue'
import Api from '@/services/methods'
import { EventBus } from '../Events.js'
import { serverImg } from '@/services/environment'
export default {
  name: 'Productos',
  components: {
    Header,
    Footer,
    Search
  },
  data () {
    return {
      arraySke: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11'],
      arrayPro: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      dialogSearch: false,
      tipoSearch: '',
      datosSearch: [],
      policeDepart: true,
      policeCat: true,
      policeSub: true,
      policeMarc: true,
      policeProd: true,
      departamentos: [],
      categorias: [],
      subcategorias: [],
      marcas: [],
      linea: '',
      seleccionCat: '',
      seleccionCatId: '',
      seleccionCatRes: '',
      seleccionSub: '',
      seleccionSubRes: '',
      seleccionMarc: '',
      seleccionMarcRes: '',
      seleccionDep: '',
      consulta: false,
      police2: false,
      policeList: false,
      pagination: {
        page: 1
      },
      maximo: 9,
      listado: [],
      productos: [],
      ruta: serverImg,
      page: 1,
      mostrarP: false,
      mostrarS: false,
      cantidad: 0,
      search: '',
      switch: false,
      searchFacets: null,
      cantidades: {},

      catalogo: '',
      skip: 0,
      car: [],
      settings: []
    }
  },
  watch: {
    '$route.query.q' (val) {
      if (val && val !== this.search) {
        this.search = val
        this.$store.commit('setSearchQuery', val)
        this.skip = 0
        this.productos = []
        this.cantidad = 0
        this.listado = []
        this.policeProd = true
        this.pagination.page = 1
        this.switch = true
        this.seleccionCat = ''
        this.seleccionSub = ''
        this.seleccionMarc = ''
        this.linea = ''
        const storeFacets = this.$store.state.searchFacets
        if (storeFacets) {
          this.searchFacets = storeFacets
          if (storeFacets.categorias && storeFacets.categorias.length > 0) {
            this.categorias = storeFacets.categorias.map(function (f) { return { _id: f._id.trim(), subl_des: f.nombre, co_subl: f._id.trim(), co_lin: f.co_lin ? f.co_lin.trim() : '' } })
            this.policeCat = false
          } else {
            Api.get('categoriaWeb/limit').then(res => { this.categorias = res.data; this.policeCat = false })
          }
          if (storeFacets.subcategorias && storeFacets.subcategorias.length > 0) {
            this.subcategorias = storeFacets.subcategorias.map(function (f) { return { co_color: f._id.trim(), des_color: f.nombre } })
            this.policeSub = false
          } else {
            Api.get('subcategoria/limit').then(res => { this.subcategorias = res.data; this.policeSub = false })
          }
          if (storeFacets.marcas && storeFacets.marcas.length > 0) {
            this.marcas = storeFacets.marcas.map(function (f) { return { co_cat: f._id.trim(), cat_des: f.nombre } })
            this.policeMarc = false
          } else {
            Api.get('marcas/limit').then(res => { this.marcas = res.data; this.policeMarc = false })
          }
        } else {
          Api.get('categoriaWeb/limit').then(res => { this.categorias = res.data; this.policeCat = false })
          Api.get('subcategoria/limit').then(res => { this.subcategorias = res.data; this.policeSub = false })
          Api.get('marcas/limit').then(res => { this.marcas = res.data; this.policeMarc = false })
        }
        this.obtenerProductos()
      }
    },
    'pagination.page': function (val) {
      if (!this.policeList) {
        this.skip = (val - 1) * 9
        this.listado = []
        this.productos = []
        this.policeProd = true
        this.syncUrl()
        this.obtenerProductos()
      } else this.policeList = false
    },
    seleccionCatId (val) {
      if (val && !this.switch) {
        if (this.consulta) {
          if (!this.police2) {
            this.$swal.fire({
              position: 'top-end',
              icon: 'info',
              title: 'Consulta en proceso, por favor espere...',
              showConfirmButton: false,
              timer: 1500
            })
            if (!this.seleccionCatRes) {
              this.$nextTick(() => {
                this.seleccionCat = ''
              })
            } else {
              this.$nextTick(() => {
                this.police2 = true
                this.seleccionCat = this.seleccionCatRes
              })
            }
          } else this.police2 = false
        } else {
          for (let i = 0; i < this.categorias.length; i++) {
            const el = this.categorias[i]
            if (el._id.trim() == val.trim()) {
              this.seleccionCat = el.co_subl
              this.linea = el.co_lin
              this.seleccionCatRes = el.co_subl
              this.seleccionDep = el.co_lin
            }
          }
          this.skip = 0
          this.policeList = true
          this.pagination.page = 1
          this.productos = []
          this.cantidad = 0
          this.listado = []
          this.search = ''
          EventBus.$emit('limpiarSearch')
          this.policeProd = true
          this.obtenerProductos()
        }
      } else if (this.switch) this.switch = false
    },
    seleccionSub (val) {
      if (val) {
        if (this.consulta) {
          if (!this.police2) {
            this.$swal.fire({
              position: 'top-end',
              icon: 'info',
              title: 'Consulta en proceso, por favor espere...',
              showConfirmButton: false,
              timer: 1500
            })
            if (!this.seleccionSubRes) {
              this.$nextTick(() => {
                this.seleccionCat = ''
              })
            } else {
              this.$nextTick(() => {
                this.police2 = true
                this.seleccionSub = this.seleccionSubRes
              })
            }
          } else this.police2 = false
        } else {
          this.seleccionSubRes = val
          this.skip = 0
          this.productos = []
          this.cantidad = 0
          this.listado = []
          this.policeList = true
          this.pagination.page = 1
          this.policeProd = true
          if (!this.searchFacets) {
            this.search = ''
            EventBus.$emit('limpiarSearch')
          }
          this.syncUrl()
          this.obtenerProductos()
        }
      }
    },
    seleccionMarc (val) {
      if (val && !this.switch) {
        if (this.consulta) {
          if (!this.police2) {
            this.$swal.fire({
              position: 'top-end',
              icon: 'info',
              title: 'Consulta en proceso, por favor espere...',
              showConfirmButton: false,
              timer: 1500
            })
            if (!this.seleccionMarcRes) {
              this.$nextTick(() => {
                this.seleccionCat = ''
              })
            } else {
              this.$nextTick(() => {
                this.police2 = true
                this.seleccionMarc = this.seleccionMarcRes
              })
            }
          } else this.police2 = false
        } else {
          this.seleccionMarcRes = val
          this.skip = 0
          this.productos = []
          this.policeList = true
          this.pagination.page = 1
          this.cantidad = 0
          this.listado = []
          this.policeProd = true
          if (!this.searchFacets) {
            this.search = ''
            EventBus.$emit('limpiarSearch')
          }
          this.syncUrl()
          this.obtenerProductos()
        }
      } else if (this.switch) this.switch = false
    }
  },
  mounted () {
    EventBus.$on('buscarProducto', data => {
      const value = (typeof data === 'object' && data.value !== undefined) ? data.value : data
      this.search = value
      this.seleccionDep = ''
      this.skip = 0
      this.productos = []
      this.cantidad = 0
      this.listado = []
      this.policeProd = true
      this.pagination.page = 1
      this.switch = true
      this.seleccionCat = ''
      this.seleccionSub = ''
      this.seleccionMarc = ''
      this.linea = ''
      document.documentElement.scrollTop = 0
      const storeFacets = this.$store.state.searchFacets
      if (storeFacets) {
        this.searchFacets = storeFacets
        if (storeFacets.categorias && storeFacets.categorias.length > 0) {
          this.categorias = storeFacets.categorias.map(function (f) { return { _id: f._id.trim(), subl_des: f.nombre, co_subl: f._id.trim(), co_lin: f.co_lin ? f.co_lin.trim() : '' } })
          this.policeCat = false
        } else {
          Api.get('categoriaWeb/limit').then(res => { this.categorias = res.data; this.policeCat = false })
        }
        if (storeFacets.subcategorias && storeFacets.subcategorias.length > 0) {
          this.subcategorias = storeFacets.subcategorias.map(function (f) { return { co_color: f._id.trim(), des_color: f.nombre } })
          this.policeSub = false
        } else {
          Api.get('subcategoria/limit').then(res => { this.subcategorias = res.data; this.policeSub = false })
        }
        if (storeFacets.marcas && storeFacets.marcas.length > 0) {
          this.marcas = storeFacets.marcas.map(function (f) { return { co_cat: f._id.trim(), cat_des: f.nombre } })
          this.policeMarc = false
        } else {
          Api.get('marcas/limit').then(res => { this.marcas = res.data; this.policeMarc = false })
        }
      } else {
        this.searchFacets = null
        Api.get('categoriaWeb/limit').then(res => { this.categorias = res.data; this.policeCat = false })
        Api.get('subcategoria/limit').then(res => { this.subcategorias = res.data; this.policeSub = false })
        Api.get('marcas/limit').then(res => { this.marcas = res.data; this.policeMarc = false })
      }
      this.obtenerProductos()
    })
    EventBus.$on('buscarCategoria', data => {
      this.$store.commit('clearSearchFacets')
      this.searchFacets = null
      this.search = ''
      document.documentElement.scrollTop = 0
      this.seleccionCatId = data._id
      this.linea = data.co_lin.trim()
      this.seleccionCat = data.co_subl.trim()
      this.seleccionCatRes = data.co_subl.trim()
      this.seleccionDep = data.co_lin.trim()
    })
  },
  async created () {
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_cli) {
      this.mostrarP = true
    }
    if (this.$store.state.fercoWeb && this.$store.state.fercoWeb.stock) {
      this.mostrarS = this.$store.state.fercoWeb.stock
    }
    if (this.$store.state.carFerco !== null) {
      this.car = this.$store.state.carFerco
    }
    const q = this.$route.query
    if (q && q.q) {
      this.search = q.q
    } else if (this.$store.state.searchQuery) {
      this.search = this.$store.state.searchQuery
    }
    if (q && q.page) {
      this.policeList = true
      this.pagination.page = parseInt(q.page) || 1
      this.skip = (this.pagination.page - 1) * 9
    }
    if (q && q.sub) {
      this.switch = true
      this.seleccionSub = q.sub
      this.seleccionSubRes = q.sub
    }
    if (q && q.marc) {
      this.switch = true
      this.seleccionMarc = q.marc
      this.seleccionMarcRes = q.marc
    }
    const facets = this.$store.state.searchFacets
    if (facets) {
      this.searchFacets = facets
    }
    if (this.$route.params && this.$route.params.depart) {
      document.documentElement.scrollTop = 0
      this.seleccionDep = this.$route.params.depart.co_lin
    }
    if (this.$route.params && this.$route.params.marca) {
      document.documentElement.scrollTop = 0
      this.switch = true
      this.seleccionMarc = this.$route.params.marca.co_cat
    }
    if (this.$route.params && this.$route.params.categoria) {
      document.documentElement.scrollTop = 0
      this.switch = true
      this.seleccionCatId = this.$route.params.categoria._id
      this.linea = this.$route.params.categoria.co_lin.trim()
      this.seleccionCat = this.$route.params.categoria.co_subl.trim()
      this.seleccionCatRes = this.$route.params.categoria.co_subl.trim()
      this.seleccionDep = this.$route.params.categoria.co_lin.trim()
    }
    await this.initialize()
  },
  methods: {
    decrementar (index) {
      const item = this.listado[index]
      const equi = parseFloat(item && item.equivalente) || 1
      const cant = this.cantidades[index] || equi
      if (cant > equi) {
        this.$set(this.cantidades, index, cant - equi)
      }
    },
    incrementar (index, item) {
      const equi = parseFloat(item.equivalente) || 1
      const cant = this.cantidades[index] || equi
      const stockEnUnidades = Math.trunc((parseFloat(item.existencia) || 0) * equi)
      if (stockEnUnidades > 0 && cant + equi > stockEnUnidades) return
      this.$set(this.cantidades, index, cant + equi)
    },
    añadirCarritoLista (item, index) {
      const equi = parseFloat(item.equivalente) || 1
      var cant = this.cantidades[index] || equi
      if (this.car && this.car.length >= 25) {
        this.$swal.fire({ position: 'top-end', icon: 'info', title: 'Ha sobrepasado el límite de productos por pedido.', showConfirmButton: false, timer: 1500 })
        return
      }
      var check = false
      var info = Object.assign({}, item, { cant: cant })
      for (var i = 0; i < this.car.length; i++) {
        if (info._id === this.car[i]._id) {
          if ((parseInt(this.car[i].cant) + cant) > parseInt(this.car[i].stock)) {
            this.$swal.fire({ position: 'top-end', icon: 'error', title: 'Ha superado el límite de existencia.', showConfirmButton: false, timer: 1500 })
          } else {
            this.$store.dispatch('agregarcarrito2', info)
            EventBus.$emit('actCarrito')
            this.car = this.$store.state.carFerco
          }
          check = true
          break
        }
      }
      if (!check) {
        this.$store.dispatch('agregarcarrito', info)
        EventBus.$emit('actCarrito')
        this.car = this.$store.state.carFerco
      }
      this.$set(this.cantidades, index, parseFloat(item.equivalente) || 1)
      this.$swal.fire({ position: 'top-end', icon: 'success', title: 'Producto agregado al carrito', showConfirmButton: false, timer: 1200 })
    },
    syncUrl () {
      var query = {}
      if (this.search) query.q = this.search
      if (this.pagination.page && this.pagination.page > 1) query.page = this.pagination.page
      if (this.seleccionSub) query.sub = this.seleccionSub
      if (this.seleccionMarc) query.marc = this.seleccionMarc
      var current = this.$route.query
      var same = (current.q === query.q || (!current.q && !query.q)) &&
                 (current.page === String(query.page) || (!current.page && !query.page)) &&
                 (current.sub === query.sub || (!current.sub && !query.sub)) &&
                 (current.marc === query.marc || (!current.marc && !query.marc))
      if (!same) this.$router.replace({ name: 'Productos', query: query })
    },
    abrirModal (item) {
      this.tipoSearch = item
      this.datosSearch = []
      if (item == 'cat') {
        for (let i = 0; i < this.categorias.length; i++) {
          const el = this.categorias[i]
          this.datosSearch.push(el)
        }
      }
      if (item == 'subcat') {
        for (let i = 0; i < this.subcategorias.length; i++) {
          const el = this.subcategorias[i]
          this.datosSearch.push(el)
        }
      }
      if (item == 'marc') {
        for (let i = 0; i < this.marcas.length; i++) {
          const el = this.marcas[i]
          this.datosSearch.push(el)
        }
      }
      this.dialogSearch = true
    },
    actionSearch (item) {
      if (this.tipoSearch == 'cat') this.seleccionCatId = item._id
      if (this.tipoSearch == 'subcat') this.seleccionSub = item.co_color
      if (this.tipoSearch == 'marc') this.seleccionMarc = item.co_cat
      this.tipoSearch = ''
      this.datosSearch = []
      this.dialogSearch = false
    },
    close () {
      this.dialogSearch = false
      this.tipoSearch = ''
      this.datosSearch = []
    },
    obtenerNombreDep (item) {
      let nomb = ''
      this.departamentos.forEach(el => {
        if (el.co_lin.trim() == item.trim()) nomb = el.lin_des
      })
      return nomb
    },
    obtenerNombreCat (item) {
      let nomb = ''
      this.categorias.forEach(el => {
        if (el._id.trim() == item.trim()) nomb = el.subl_des
      })
      return nomb
    },
    obtenerNombreSub (item) {
      let nomb = ''
      this.subcategorias.forEach(el => {
        if (el.co_color.trim() == item.trim()) nomb = el.des_color
      })
      return nomb
    },
    obtenerNombreMarc (item) {
      let nomb = ''
      this.marcas.forEach(el => {
        if (el.co_cat.trim() == item.trim()) nomb = el.cat_des
      })
      return nomb
    },
    obtenerDepart (item) {
      this.$store.commit('clearSearchFacets')
      this.searchFacets = null
      if (this.consulta) {
        this.$swal.fire({
          position: 'top-end',
          icon: 'info',
          title: 'Consulta en proceso, por favor espere...',
          showConfirmButton: false,
          timer: 1500
        })
      } else {
        this.seleccionDep = item
        this.seleccionCat = ''
        this.linea = ''
        this.skip = 0
        this.productos = []
        this.cantidad = 0
        this.policeList = true
        this.pagination.page = 1
        this.listado = []
        this.policeProd = true
        this.search = ''
        EventBus.$emit('limpiarSearch')
        this.obtenerProductos()
      }
    },
    limpiarDep () {
      this.$store.commit('clearSearchFacets')
      this.searchFacets = null
      this.seleccionDep = ''
      this.skip = 0
      this.productos = []
      this.cantidad = 0
      this.listado = []
      this.policeProd = true
      this.search = ''
      EventBus.$emit('limpiarSearch')
      this.obtenerProductos()
    },
    limpiarCat () {
      this.linea = ''
      this.seleccionDep = ''
      this.seleccionCatId = ''
      this.seleccionCat = ''
      this.skip = 0
      this.productos = []
      this.cantidad = 0
      this.listado = []
      this.policeProd = true
      if (!this.searchFacets) {
        this.search = ''
        EventBus.$emit('limpiarSearch')
      }
      this.obtenerProductos()
    },
    limpiarSub () {
      this.seleccionSub = ''
      this.skip = 0
      this.productos = []
      this.cantidad = 0
      this.listado = []
      this.policeProd = true
      if (!this.searchFacets) {
        this.search = ''
        EventBus.$emit('limpiarSearch')
      }
      this.syncUrl()
      this.obtenerProductos()
    },
    limpiarMarc () {
      this.seleccionMarc = ''
      this.skip = 0
      this.productos = []
      this.cantidad = 0
      this.listado = []
      this.policeProd = true
      if (!this.searchFacets) {
        this.search = ''
        EventBus.$emit('limpiarSearch')
      }
      this.syncUrl()
      this.obtenerProductos()
    },
    imagenes (item, index) {
      this.$nextTick(() => {
        const rut = this.ruta
        if (document.getElementById('imgg' + index)) {
          var holder = null
          var i = 1
          $('#imgg' + index).hover(function () {
            if (item[1] && item[1].url) {
              holder = setInterval(switchImages, 1000)
              // $(this).attr('src', rut + item[1].url)
            }
          }, function () {
            $(this).attr('src', rut + item[0].url)
            clearInterval(holder)
          })
          function switchImages () {
            if (item[i]) {
              $('#imgg' + index).attr('src', rut + item[i].url)
              i++
            } else {
              i = 0
            }
          }
        }
      })
    },
    ir (item) {
      this.$router.push('/detalle/' + item)
    },
    listar () {
      const val = this.cantidad / this.maximo
      if (val % 1 === 0) {
        return this.cantidad / this.maximo
      } else {
        const num = Math.trunc(this.cantidad / this.maximo)
        return num + 1
      }
    },
    obtenerProductos () {
      this.consulta = true
      const cli = (this.$store.state.fercoWeb && this.$store.state.fercoWeb.co_precio) ? this.$store.state.fercoWeb.co_precio.trim() : null
      Api.get(
        'productosCom/randomWeb?skip=' + this.skip +
        '&departamento=' + this.seleccionDep +
        '&categoria=' + this.seleccionCat +
        '&linea=' + this.linea +
        '&subcategoria=' + this.seleccionSub +
        '&marcas=' + this.seleccionMarc +
        '&codigo=' + cli +
        '&search=' + this.search
      ).then(res => {
        this.consulta = false
        this.$nextTick(() => {
          this.productos = res.data.resultados
          this.cantidad = res.data.cantidad
          for (let i = 0; i < this.productos.length; i++) {
            const prod = this.productos[i]
            const equi = parseFloat(prod.equivalente) || 1
            this.listado.push({
              _id: prod._id,
              nombre: prod.art_des,
              art_des: prod.art_des,
              marca: prod.marcaN,
              ref: prod.ref,
              modelo: prod.modelo,
              campo4: prod.campo4,
              existencia: prod.stock,
              stock: prod.stock,
              images: prod.imagen || null,
              imagen: prod.imagen ? [prod.imagen] : [],
              precio: prod.precio,
              precioUnidad: equi > 1 ? parseFloat((prod.precio / equi).toFixed(2)) : prod.precio,
              equivalente: equi,
              equivalencia: prod.equivalencia,
              unidades: prod.unidades,
              unidad: prod.unidad,
              co_precio: prod.co_precio,
              iva: prod.iva,
              campo8: prod.campo8,
              tipo_imp: prod.tipo_imp,
              cant: 0
            })
          }
          this.policeList = false
          this.policeProd = false
        })
      }).catch(err => {
        console.log(err)
        this.consulta = false
      })
    },
    initialize () {
      this.listado = []
      this.skip = 0
      this.consulta = false
      Api.get('departamentos/withImg').then(res => {
        this.departamentos = res.data
        this.policeDepart = false
      })
      const facets = this.searchFacets
      if (facets && facets.categorias && facets.categorias.length > 0) {
        this.categorias = facets.categorias.map(function (f) { return { _id: f._id.trim(), subl_des: f.nombre, co_subl: f._id.trim(), co_lin: f.co_lin ? f.co_lin.trim() : '' } })
        this.policeCat = false
      } else {
        Api.get('categoriaWeb/limit').then(res => {
          this.categorias = res.data
          this.policeCat = false
        })
      }
      if (facets && facets.subcategorias && facets.subcategorias.length > 0) {
        this.subcategorias = facets.subcategorias.map(function (f) { return { co_color: f._id.trim(), des_color: f.nombre } })
        this.policeSub = false
      } else {
        Api.get('subcategoria/limit').then(res => {
          this.subcategorias = res.data
          this.policeSub = false
        })
      }
      if (facets && facets.marcas && facets.marcas.length > 0) {
        this.marcas = facets.marcas.map(function (f) { return { co_cat: f._id.trim(), cat_des: f.nombre } })
        this.policeMarc = false
      } else {
        Api.get('marcas/limit').then(res => {
          this.marcas = res.data
          this.policeMarc = false
        })
      }
      this.obtenerProductos()
      // Api.get('settings/catalogo2').then(res => {
      //   this.catalogo = res.data
      // })
    }
  }
}
</script>
<style lang="scss">
@import "~@/assets/scss/productos.scss";
.VueCarousel-inner {
    flex-basis: 160px !important;
}
</style>
